export default {
  GA_MEASUREMENT_ID : 'UA-110941719-1'
};
